import { Directive, HostListener, Input, ElementRef, Renderer2 } from '@angular/core';
import { NgModel } from '@angular/forms';
@Directive({ selector: '[appIntegerOnly]' })
export class IntegerOnlyDirective {
  @Input() allowNegative: boolean = false;
  NEGATIVE_NUMBER_REGEX = /(?!^)-|[^0-9-]/g;
  POSITIVE_NUMBER_REGEX = /[^0-9]*/g;
  constructor(private el: ElementRef, private ngModel: NgModel, private renderer: Renderer2) {}
  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input) return;
    this.processValue(input.value);
  }
  @HostListener('blur', ['$event'])
  onBlur(event: any) {
    const input = event.target as HTMLInputElement;
    if (!input) return;
    this.processValue(input.value);
  }
  processValue(value: string): void {
    if (typeof value !== 'string') return;
    let cleanedValue = this.allowNegative
      ? value.replace(this.NEGATIVE_NUMBER_REGEX, '')
      : value.replace(this.POSITIVE_NUMBER_REGEX, '');

    let sign = '';
    if (this.allowNegative && cleanedValue.startsWith('-')) {
      sign = '-';
      cleanedValue = cleanedValue.replace(/^-/, '');
    }

    // Remove leading zeros on the digit-only portion BEFORE formatting commas.
    cleanedValue = cleanedValue.replace(/^0+(?=\d)/, '');

    let formattedValue = cleanedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (sign) {
      formattedValue = sign + formattedValue;
    }

    this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
    this.ngModel.update.emit(formattedValue);
  }
}